<div class="reward-details-root">
  <app-header>{{reward.name}}</app-header>
  <div class="paragraph">
    <app-paragraph>{{reward.description}}</app-paragraph>
    <app-paragraph bold *ngIf="!loading">{{this.rewardRedeemDisclaimer}}</app-paragraph>
    <div class="series-header">
      <app-filter-container [isSingleSelection]="true"
                        (selectFilterClick)="updateFilter($event)"
                        [seriesChips]="this.seriesChips"
                        [filters]="this.seriesFilter"
      ></app-filter-container>
      <div class="total-points">
        <mat-icon class="stars">stars</mat-icon>
        <div class="total-points-value">
          {{pointSummary?.totalPoints | number: '':language}}
        </div>
      </div>
      
    </div>
    <div class="reward-card">
      <app-reward-card [reward]="reward" [disabled]="!redeemable || loading" [familyId]="familyId!"></app-reward-card>
    </div>
  </div>
</div>
